import {Record as record} from 'immutable';
import {MAP_API_KEY} from '../constants/map';

export default record(
    {
        unveiled: false,
        lat: 30.26,
        lng: 97.74,
        exact: true,
        apiKey: MAP_API_KEY,
        language: 'en_US',
        region: 'US',
        labels: {}
    },
    'MapRecord'
);
